import React, { useState } from 'react';
import { db } from "../../assets/firebase/firebaseconfig";
import { ref, get, child, update } from "firebase/database";
import { useNavigate } from 'react-router-dom';
import './styles.css'; // Nhớ import file CSS mới
import { Helmet } from 'react-helmet-async';
const ForgotPassword = () => {
  const [username, setUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [step, setStep] = useState(1);
  const navigate = useNavigate();

  // Giữ nguyên logic xử lý của bạn
  const handleCheckUser = async () => {
    const cleanUser = username.trim().toLowerCase();
    const dbRef = ref(db);
    const snapshot = await get(child(dbRef, `user_admin/${cleanUser}`));
    if (snapshot.exists()) {
      setStep(2);
    } else {
      alert("Tên đăng nhập không tồn tại!");
    }
  };

  const handleUpdatePassword = async () => {
    if (newPassword.length < 6) return alert("Mật khẩu tối thiểu 6 ký tự!");
    const cleanUser = username.trim().toLowerCase();
    await update(ref(db, `user_admin`), { [cleanUser]: newPassword });
    alert("Cập nhật thành công!");
    navigate("/admin/login");
  };

  return (
    <div className="forgot-password-page">
      <Helmet>
        <title key="no-pass">Quên mật khẩu admin</title>
      </Helmet>
      <div className="forgot-password-card">
        <h2>QUÊN MẬT KHẨU</h2>
        
        {step === 1 ? (
          <>
            <p>Nhập tên tài khoản để đặt lại mật khẩu của bạn</p>
            <div className="input-group">
              <label>Tên đăng nhập</label>
              <input 
                type="text" 
                placeholder="Ví dụ: admin123" 
                onChange={e => setUsername(e.target.value)} 
              />
            </div>
            <button className="btn-primary" onClick={handleCheckUser}>TIẾP TỤC</button>
          </>
        ) : (
          <>
            <p>Tài khoản: <b>{username}</b></p>
            <div className="input-group">
              <label>Mật khẩu mới</label>
              <input 
                type="password" 
                placeholder=" Nhập mật khẩu mới..." 
                onChange={e => setNewPassword(e.target.value)} 
              />
            </div>
            <button className="btn-primary" onClick={handleUpdatePassword}>XÁC NHẬN ĐỔI</button>
          </>
        )}
        
        <a href="#" onClick={() => navigate("/admin/login")} className="back-link">
          ← Quay lại đăng nhập
        </a>
      </div>
    </div>
  );
};

export default ForgotPassword;
